export const WORK_ORDER_TRACK_PAGE_V2_EVENT = "V2 WO Track Page";
export const WORK_ORDER_TRACK_PAGE_V2_STEPS = {
  ENTRY: "Entry",
  SIDE_FILTER_APPLIED: "Side Filter Applied"
};
